import { Field, ErrorMessage } from 'formik';
import { cn } from '@/utils/cn';

interface TextareaProps {
  name: string;
  placeholder?: string;
  label?: string;
  className?: string;
  rows?: number;
  required?: boolean;
}

const Textarea = ({ name, placeholder, label, className, rows = 4, required }: TextareaProps) => {
  return (
    <div className="w-full">
      {label && (
        <label htmlFor={name} className="block text-sm font-bold text-gray-900 mb-2">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <Field
        as="textarea"
        id={name}
        name={name}
        rows={rows}
        placeholder={placeholder}
        className={cn(
          'w-full border border-gray-300 rounded-xl px-3.5 py-2.5 text-sm font-medium text-gray-900 outline-none focus:outline-none focus:border-[#FC480D] resize-none',
          className
        )}
      />
      <ErrorMessage name={name} component="div" className="text-red-500 text-xs mt-1" />
    </div>
  );
};

export default Textarea;
